import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ServiceInfoDc } from "@evergis/api";

import { useTableSelectedCount } from "../../../../../../hooks/table/useTableSelectedCount";
import { useTableSelection } from "../../../../../../hooks/table/useTableSelection";
import { useDialogInfo } from "../../../../../../hooks/useDialogs";
import { getSelectedFeaturesTotalCounts } from "../../../../../../ducks/selectFeatures/selectors";

import { LayerInfo } from "../../../../../../interfaces/resourceInfo";

export const useRowsCount = (layerInfo: ServiceInfoDc | LayerInfo): number => {
  const { options } = useDialogInfo();
  const [tableSelection] = useTableSelection();
  const { selectedCount } = useTableSelectedCount(options?.fromTable ? layerInfo.name : undefined);
  const totalCounts = useSelector(getSelectedFeaturesTotalCounts);

  const count = useMemo(
    () => (tableSelection?.[layerInfo.name] ? selectedCount : (layerInfo as ServiceInfoDc)?.objectCount),
    [layerInfo, selectedCount, tableSelection],
  );

  return options?.fromFeatureCard ? totalCounts?.[layerInfo.name] : count;
};
